
import { defineComponent } from "vue";
import SvgSprite from "~/components/other/SvgSprite.vue";
import Dialog from "@/components/base/BaseDialog.vue";
import Snackbar from "./Snackbar.vue";

export default defineComponent({
	components: {
		SvgSprite,
		Dialog,
		Snackbar,
	},
	setup() {
		const version = process.env.PACKAGE_VERSION;
		return { version };
	},
});
